import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { AddEditPurchaseForm } from "../../components/purchase";
import { PageHeader } from "../../components/v3";

export const AddEditPurchase = () => {
  const { id } = useParams();
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title={id ? "Edit Purchase" : "Add Purchase"} />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditPurchaseForm purchaseId={id} />
      </Box>
    </PageLayout>
  );
};
